export const getCellKey = (rowId: string, columnId: string) =>
  `${rowId}_${columnId}`;
